<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="安全投入名称">
          <el-input placeholder="请输入安全投入名称" v-model="formInline.search">

          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

          <!-- <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button> -->

        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加安全投入</el-button>
      <el-button size="small" icon="el-icon-printer" type="success" @click="printSelected">打印选中</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>

            <el-table-column prop="name" label="安全投入名称"></el-table-column>
            <!-- 上期营收 -->
<el-table-column prop="last_period_revenue" label="上期营收"></el-table-column>
<!-- 提现比例 -->
<el-table-column prop="withdrawal_ratio" label="提现比例"></el-table-column>
<!-- 上期结余 -->
<el-table-column prop="last_period_balance" label="上期结余"></el-table-column>
<!-- 已使用金额 -->
<el-table-column prop="used_amount" label="已使用金额"></el-table-column>
<!-- 剩余金额 -->
<el-table-column prop="remaining_amount" label="剩余金额"></el-table-column>
<!-- 审核状态 -->
<el-table-column prop="audit_status" label="审核状态">
  <template slot-scope="scope">
    {{ scope.row.audit_status === 0 ? '未审核' : '已审核' }}
  </template>
</el-table-column>
<!-- 编制日期 -->
<el-table-column prop="compile_date" label="编制日期"></el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="printClick(scope.row)" type="text" size="small">打印</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_safety_investment_id="ma_safety_investment_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
                :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <!-- 打印预览弹窗 -->
    <el-dialog title="打印预览" :visible.sync="printDialogVisible" width="80%" @close="closePrintDialog" class="print-preview-dialog" append-to-body>
      <div ref="printContent" class="print-content">
        <div class="print-title">安全投入列表（共 {{ printDataList ? printDataList.length : 0 }} 条）</div>
        <table class="print-table" border="1" cellpadding="10" cellspacing="0">
          <thead>
            <tr>
              <th>安全投入名称</th>
              <th>上期营收</th>
              <th>提现比例</th>
              <th>上期结余</th>
              <th>已使用金额</th>
              <th>剩余金额</th>
              <th>审核状态</th>
              <th>编制日期</th>
              <th>排序</th>
              <th>创建时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in printDataList" :key="item.ma_safety_investment_id">
              <td>{{ item.name }}</td>
              <td>{{ item.last_period_revenue }}</td>
              <td>{{ item.withdrawal_ratio }}</td>
              <td>{{ item.last_period_balance }}</td>
              <td>{{ item.used_amount }}</td>
              <td>{{ item.remaining_amount }}</td>
              <td>{{ item.audit_status === 0 ? '未审核' : '已审核' }}</td>
              <td>{{ item.compile_date }}</td>
              <td>{{ item.sort }}</td>
              <td>{{ item.create_time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePrintDialog">取消</el-button>
        <el-button type="primary" icon="el-icon-printer" @click="doPrint">打印</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Ma_safety_investmentApi from '@/api/ma_safety_investment.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search:""
      },

      open_add:false,
      open_edit:false,
      ma_safety_investment_id:"",
      dialogVisible:false,
      open_import:false,
      printDialogVisible:false,
      printDataList: [],
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    dialogFormVisible(){
      this.dialogVisible = false;
    },
    setting(e){//安全投入标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /* 清空选择 */
    clearSelection() {
      if (this.multipleTable) {
        this.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    importClick() {
      this.open_import = true;
    },
    exportData() {
      // 构建导出参数
      let exportParams = {
        name: this.formInline.name,
      };

      // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.ma_safety_investment_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      // 使用页面跳转方式导出，避免blob处理
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '')
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.ma_safety_investment.Index/export?' + queryString;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Ma_safety_investmentApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true
    },

    /*编辑活动*/
    editClick(row) {
      this.ma_safety_investment_id = row.ma_safety_investment_id;
      this.open_edit = true
    },

    /*打印单条*/
    printClick(row) {
      this.printDataList = [row];
      this.printDialogVisible = true;
    },

    /*打印选中多条*/
    printSelected() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条记录');
        return;
      }
      this.printDataList = this.selectedRows;
      this.printDialogVisible = true;
    },

    closePrintDialog() {
      this.printDialogVisible = false;
      this.printDataList = [];
    },

    doPrint() {
      const printNode = this.$refs.printContent;
      if (!printNode) return;
      const win = window.open('', '_blank');
      if (!win) {
        this.$message.warning('请允许弹窗以进行打印');
        return;
      }
      win.document.write('<html><head><meta charset="utf-8"><title>安全投入列表</title><style>body{font-family:Microsoft YaHei,sans-serif;padding:20px;} table{width:100%;border-collapse:collapse;} .print-title{font-size:18px;font-weight:bold;text-align:center;margin-bottom:20px;} th{background:#f5f5f5;font-weight:bold;padding:8px;} td{border:1px solid #ddd;padding:8px;}</style></head><body>');
      win.document.write(printNode.innerHTML);
      win.document.write('</body></html>');
      win.document.close();
      win.onload = function() { win.print(); win.close(); };
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_safety_investmentApi.del(
                {
                  ma_safety_investment_id: row.ma_safety_investment_id
                },
                true
            )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    }
  }
};
</script>

<style scoped>
.print-content {
  padding: 20px;
}

.print-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.print-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.print-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  padding: 8px;
  border: 1px solid #ddd;
}

.print-table td {
  padding: 8px;
  border: 1px solid #ddd;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_safety_investment/index/index.vue